import { ComponentStyleConfig } from '@chakra-ui/react';

export const Avatar: ComponentStyleConfig = {
  baseStyle: {
    container: {
      fontWeight: 400,
    },
  },
  sizes: {
    '3xl': {
      container: {
        width: 128,
        height: 128,
      },
      label: {
        fontSize: 42,
      },
      excessLabel: {
        width: 128,
        height: 128,
      },
    },
    '2xl': {
      container: {
        width: 20,
        height: 20,
      },
      label: {
        fontSize: 42,
      },
      excessLabel: {
        width: 24,
        height: 24,
      },
    },
    xl: {
      container: {
        width: 14, // 56
        height: 14,
      },
      label: {
        fontSize: 'xl',
      },
      excessLabel: {
        width: 14,
        height: 14,
      },
    },
    lg: {
      container: {
        width: 13,
        height: 13,
      },
      label: {
        fontSize: 'lg',
        fontWeight: 400,
      },
    },
    md: {
      container: {
        width: 10,
        height: 10,
      },
      label: {
        fontSize: 'lg',
        fontWeight: 400,
      },
      excessLabel: {
        width: 10,
        height: 10,
      },
    },
    sm: {
      container: {
        width: 8, // 32
        height: 8,
      },
      label: {
        fontSize: 'md',
        fontWeight: 400,
      },
      excessLabel: {
        width: 8,
        height: 8,
      },
    },
    xs: {
      container: {
        width: 7, // 28
        height: 7,
      },
      label: {
        fontSize: 'xs',
      },
      excessLabel: {
        width: 7,
        height: 7,
      },
    },
    xxs: {
      container: {
        width: 6, // 24
        height: 6,
      },
      label: {
        fontSize: 'xxs',
        fontWeight: 600,
      },
      excessLabel: {
        width: 6,
        height: 6,
      },
    },
  },
};
